var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Refresh = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M16.5187 9.34685H21.0187M21.0187 9.34685V4.84685M21.0187 9.34685L17.8312 6.16873C17.0658 5.40224 16.1569 4.79417 15.1563 4.37929C14.1557 3.9644 13.0831 3.75085 12 3.75085C10.9168 3.75085 9.84421 3.9644 8.84362 4.37929C7.84304 4.79417 6.93407 5.40224 6.1687 6.16873M7.4812 14.6531H2.9812M2.9812 14.6531V19.1531M2.9812 14.6531L6.1687 17.8312C6.93407 18.5977 7.84304 19.2058 8.84362 19.6207C9.84421 20.0356 10.9168 20.2491 12 20.2491C13.0831 20.2491 14.1557 20.0356 15.1563 19.6207C16.1569 19.2058 17.0658 18.5977 17.8312 17.8312", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
